import { defineComponent as _defineComponent } from 'vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import SvgIcons from './SvgIcons.vue';
import { isElIcon, isFaIcon, isSvgIcon, type JJIconType, toELIcon, toFaIcon } from './types'

const __default__ = {
    name: 'JJIcons',
    render(createElement, hack) {
        const type = this.$props.type
        const onClick = event => this.$emit('click', event)
        const dataIcon = {}
        const rootData = { attrs: { 'data-icon': '' }, class: 'jj-icon', on: { click: onClick } }
        if (isSvgIcon(type)) {
            return createElement('span', rootData, [
                createElement(SvgIcons, { ...dataIcon, props: { type: type } })
            ])
        }
        if (isFaIcon(type)) {
            return createElement('span', rootData, [
                createElement(FontAwesomeIcon, { ...dataIcon, props: { icon: ['fas', toFaIcon(type)] } })
            ])
        }
        if (isElIcon(type)) {
            return createElement('i', { attrs: { 'data-icon': '' }, class: ['jj-icon', toELIcon(type)], on: { click: onClick } })
        }
    },
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    type: null
  },
  setup(__props: any) {

const props = __props as {
    type: JJIconType
}



return { __sfc: true,props, FontAwesomeIcon, SvgIcons, isElIcon, isFaIcon, isSvgIcon, toELIcon, toFaIcon }
}

})